import { render, staticRenderFns } from "./addFloor.vue?vue&type=template&id=7ae36f46"
import script from "./addFloor.vue?vue&type=script&lang=js"
export * from "./addFloor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports